import React from "react";

const EnquirySuccess = () => {
  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-body">
          {/* Success Icon */}
          <div className="success-icon">
            <i className="fa fa-check"></i>
          </div>

          {/* Heading */}
          <h2 className="success-title">Enquiry Submitted Successfully!</h2>

          {/* Description */}
          <p className="success-text">
            Thank you for contacting us. We have received your enquiry and our
            team will get in touch with you shortly.
          </p>

          {/* Information */}
          <div className="feature-heading">What happens next?</div>

          <div className="feature-list">
            <div className="feature-item">
              <i className="fa fa-phone"></i>
              <span>Our team will contact you shortly.</span>
            </div>

            <div className="feature-item">
              <i className="fa fa-comments"></i>
              <span>We'll answer your questions and provide guidance.</span>
            </div>

            <div className="feature-item">
              <i className="fa fa-calendar-check-o"></i>
              <span>Schedule a visit or trial session if required.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquirySuccess;
